export const AUTO_DATA_OPT_OUT = 'AutoDataOptOut';
export const SHOW_DATA_OPT_OUT = 'ShowDataOptOut';
export const JURISDICTION = 'Jurisdiction';
export const EXPIRED_LIMIT = 300000;
